import { RootState } from "app/store";
import { validatePassword } from "common/validatePassword";

export const selectPasswordValidationErrors = (state: RootState) => {
  const { password, passwordCheck } = state.reset.apps;
  return validatePassword(password, passwordCheck);
};
export const selectEmail = (state: RootState) => state.reset.apps.email;
export const selectPassword = (state: RootState) => state.reset.apps.password;
export const selectPasswordCheck = (state: RootState) =>
  state.reset.apps.passwordCheck;
export const selectCode = (state: RootState) => state.reset.apps.code;
export const selectPageState = (state: RootState) => state.reset.apps.pageState;
